module.exports = __webpack_public_path__ + "static/media/06-kittel_schuhe.ea0c47ef.jpg";